export enum DatasetTypeEnum {
    STUDY_CONDITIONS = 1,
    MEANS = 2,
    ENVIRONMENT = 3,
    PLOT = 4,
    PLANT_SUBOBSERVATIONS = 5,
    QUADRAT_SUBOBSERVATIONS = 6,
    TIME_SERIES_SUBOBSERVATIONS = 7,
    CUSTOM_SUBOBSERVATIONS = 8,
    SUMMARY_STATISTICS_DATA = 12,
}

export const DATASET_TYPES_OBSERVATION_IDS = [
    DatasetTypeEnum.PLANT_SUBOBSERVATIONS,
    DatasetTypeEnum.CUSTOM_SUBOBSERVATIONS,
    DatasetTypeEnum.QUADRAT_SUBOBSERVATIONS,
    DatasetTypeEnum.TIME_SERIES_SUBOBSERVATIONS,
    DatasetTypeEnum.PLOT,
];

export const DATASET_TYPES_SUB_OBSERVATION_IDS = [
    DatasetTypeEnum.PLANT_SUBOBSERVATIONS,
    DatasetTypeEnum.CUSTOM_SUBOBSERVATIONS,
    DatasetTypeEnum.QUADRAT_SUBOBSERVATIONS,
    DatasetTypeEnum.TIME_SERIES_SUBOBSERVATIONS
];
